import { render, staticRenderFns } from "./PatientDetailAppealsItem.vue?vue&type=template&id=61cf62a6&scoped=true"
import script from "./PatientDetailAppealsItem.vue?vue&type=script&lang=js"
export * from "./PatientDetailAppealsItem.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailAppealsItem.vue?vue&type=style&index=0&id=61cf62a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf62a6",
  null
  
)

export default component.exports